import React from 'react';
import { useMe } from '@/context/MeContext';
import { useSupportMode } from '@/context/SupportModeContext';

export default function SupportModeBanner() {
  const { me } = useMe();
  const { supportMode, clearSupportMode } = useSupportMode();

  if (!supportMode.active) {
    return null;
  }

  const viewedOrg =
    supportMode.organizationName ??
    supportMode.organizationId ??
    me?.organizationId ??
    'unknown organization';
  const viewedUser = supportMode.targetUserId ?? 'all users in org';
  const actor = supportMode.actorEmail ?? me?.email ?? 'support actor';
  const actorRole = supportMode.actorRole ?? me?.role ?? 'support';

  return (
    <div className="support-mode-banner" role="status" data-testid="support-mode-banner">
      <div className="support-mode-banner__content">
        <strong>Support mode active</strong>
        <span>
          Viewing organization <strong>{viewedOrg}</strong>
          {supportMode.targetUserId ? (
            <>
              {' '}
              · user <code>{viewedUser}</code>
            </>
          ) : null}
        </span>
        <span className="muted">
          Actor: {actor} ({actorRole}). Read-only support view — destructive actions are disabled.
        </span>
        {supportMode.message ? <span className="muted">{supportMode.message}</span> : null}
      </div>
      <button type="button" className="btn btn-ghost btn-sm" onClick={clearSupportMode}>
        Exit support view
      </button>
    </div>
  );
}
